import { motion } from 'framer-motion'
import '../styles/BaixarSuporte.css'
import { LampContainer } from '@/components/ui/lamp'

// Links oficiais: sempre baixam a versão mais recente de cada ferramenta
const ferramentas = [
  {
    nome: 'AnyDesk',
    img: '/img/suporte/AnyDesk.png',
    desc: 'Ferramenta leve e rápida para acesso remoto ao seu computador.',
    url: 'https://download.anydesk.com/AnyDesk.exe',
  },
  {
    nome: 'AnyViewer',
    img: '/img/suporte/AnyViewer.png',
    desc: 'Acesso remoto gratuito, seguro e fácil de usar.',
    url: 'https://go.anyviewer.com/dl/AnyViewerSetup_x64.exe',
  },
]

const passos = [
  <>Fale com nossa equipe pelo WhatsApp <strong>(63)&nbsp;98404-2819</strong>.</>,
  <>Baixe a ferramenta indicada pelo técnico e execute o arquivo.</>,
  <>Informe o código de acesso gerado para o técnico.</>,
  <>Aguarde enquanto resolvemos seu problema!</>,
]

export default function BaixarSuporte() {
  return (
    <div style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>

      {/* ══ HERO ══ */}
      <LampContainer
        className="min-h-[22rem] md:min-h-[25rem] rounded-none pt-36 md:pt-44"
        lampClassName="translate-y-10"
        contentClassName="-translate-y-32"
        overlay={
          <div
            className="absolute inset-0 z-10 pointer-events-none"
            style={{
              backgroundImage:
                'linear-gradient(rgba(26, 62, 115, 0.15) 1px, transparent 1px), linear-gradient(90deg, rgba(26, 62, 115, 0.15) 1px, transparent 1px)',
              backgroundSize: '48px 48px',
            }}
          />
        }
      >
        <motion.h1
          initial={{ opacity: 0.5, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.3,
            duration: 0.8,
            ease: 'easeInOut',
          }}
          className="mt-8 bg-gradient-to-br from-slate-300 to-slate-500 py-4 bg-clip-text text-center text-3xl font-medium tracking-tight text-transparent sm:text-4xl md:text-7xl px-4"
        >
          Baixar Suporte
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{
            delay: 0.45,
            duration: 0.8,
            ease: 'easeInOut',
          }}
          className="mt-2 max-w-xl text-center text-base text-slate-400 px-4"
        >
          Baixe a ferramenta indicada pelo nosso técnico para que possamos acessar seu computador de forma segura e resolver seu problema.
        </motion.p>
      </LampContainer>

      {/* ══ CORPO ══ */}
      <div className="bs-body">
        <div className="bs-body-inner">

          {/* ── Ferramentas ── */}
          <div className="bs-card">
            <div className="bs-card-head">
              <div className="bs-card-icon">
                <i className="fa-solid fa-headset" aria-hidden="true" />
              </div>
              <div>
                <h2 className="bs-card-title">Ferramentas de acesso remoto</h2>
                <p className="bs-card-sub">Baixe a que o nosso técnico indicar. As duas funcionam no Windows.</p>
              </div>
            </div>

            <ul className="bs-tools">
              {ferramentas.map(({ nome, img, desc, url }) => (
                <li key={nome} className="bs-tool">
                  <img src={img} alt="" width={72} height={72} className="bs-tool-logo" />
                  <div className="bs-tool-info">
                    <h3 className="bs-tool-name">{nome}</h3>
                    <p className="bs-tool-desc">{desc}</p>
                    <span className="bs-tool-meta">
                      <i className="fa-brands fa-windows" aria-hidden="true" />
                      Windows · download oficial
                    </span>
                  </div>
                  <a href={url} rel="noopener noreferrer" className="bs-download-btn">
                    <i className="fa-solid fa-download" aria-hidden="true" />
                    Baixar {nome}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* ── Lateral ── */}
          <aside className="bs-lateral">
            <div className="bs-side-card">
              <h2 className="bs-side-title">Como funciona o suporte remoto?</h2>
              <ol className="bs-steps">
                {passos.map((texto, i) => (
                  <li key={i}>
                    <span className="bs-step-num">{i + 1}</span>
                    <p>{texto}</p>
                  </li>
                ))}
              </ol>
            </div>

            <div className="bs-side-card bs-side-card--escuro">
              <div className="bs-seguro-topo">
                <div className="bs-side-icon">
                  <i className="fa-solid fa-shield-halved" aria-hidden="true" />
                </div>
                <h2 className="bs-side-title">Acesso seguro</h2>
              </div>
              <p className="bs-side-text">
                O técnico só acessa o seu computador depois que você informa o código e aceita a conexão.
              </p>
              <a href="https://wa.me/5563984042819" target="_blank" rel="noreferrer" className="bs-side-btn">
                <i className="fa-brands fa-whatsapp" aria-hidden="true" />
                Falar no WhatsApp
              </a>
            </div>
          </aside>

        </div>
      </div>

    </div>
  )
}
